import clone from "clone";
import actions from "./actions";

const initState = {
  showScanModal: false,
  showScanner: false,
  scanQRTableSuccess: false,
  scanAgain: false,
  touchSaleTables: [],
  originalTouchSaleTables: [],
  users: [],
  tables: [],
  originalUsers: [],
  originalTables: [],
  scannedQRTable: null,
  tableScanStatus: "",
  // we use this field when we dont wanna show scanner
  autofilllGuid: false,
};

export default function qrReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.CHANGE_EXIST_QR_CODE:
      return {
        ...state,
        tableScanStatus: 2,
      };
    case actions.TOGGAL_SCAN_QR_MODAL:
      let filterTouchSaleTables1 = state.originalTouchSaleTables.filter(
        (u) => state.tables.filter((t) => t.name === u.name).length === 0
      );

      if (state.scanQRTableSuccess) {
        return {
          ...state,
          scannedQRTable: null,
          scanQRTableSuccess: false,
          tableScanStatus: "",
          showScanModal: false,
        };
      }
      if (state.scanAgain) {
        return {
          ...state,

          tableScanStatus: "",
          scannedQRTable: null,

          scanAgain: false,
          showScanner: false,
          showScanModal: false,
          touchSaleTables: clone(filterTouchSaleTables1),
        };
      }
      // if we scan code successfully, showScanner is already false
      return {
        ...state,
        showScanModal: !state.showScanModal,
        showScanner: state.autofilllGuid
          ? state.showScanner
          : !state.showScanner,
        touchSaleTables: clone(filterTouchSaleTables1),
        autofilllGuid: state.autofilllGuid
          ? !state.autofilllGuid
          : state.autofilllGuid,
      };

    case actions.GET_TOUCHSALE_TABLES_SUCCESS:
      return {
        ...state,
        touchSaleTables: action.touchSaleTables,
        originalTouchSaleTables: action.touchSaleTables,
      };

    case actions.SET_TABLE_STATUS_SUCCESS:
      state.originalTables.filter(
        (t) => t.identifier === action.identifier
      )[0].active = action.status;

      return {
        ...state,
      };

    case actions.STOP_SCAN:
      return {
        ...state,
        showScanner: false,
      };

    case actions.CREATE_QR_USER_SUCCESS:
      state.user["id"] = action.user.id;
      state.users.unshift(state.user);

      return {
        ...state,
        users: clone(state.users),
        showAddModal: false,
      };

    case actions.DELETE_QR_TABLE_SUCCESS:
      let tables = state.tables.filter(
        (u) => u.identifier !== action.table.identifier
      );
      let filterTouchSaleTables2 = state.originalTouchSaleTables.filter(
        (u) =>
          state.tables.filter((t) => t.identifier === u.identifier).length === 0
      );

      return {
        ...state,
        tables: clone(tables),
        touchSaleTables: clone(filterTouchSaleTables2),
      };

    case actions.NEW_SCAN:
      return {
        ...state,
        scanQRTableSuccess: false,
        scanAgain: true,
        showScanner: true,
      };

    case actions.CREATE_QR_TABLE_SUCCESS:
      state.tables.unshift(action.table);

      return {
        ...state,
        showScanModal: false,
        showScanner: false,
        scannedQRTable: null,
        tables: clone(state.tables),
      };

    case actions.SAVE_QR_TABLE_SUCCESS:
      const index = state.tables.findIndex(
        (o) => o.identifier === action.table.table.identifier
      );
      state.tables[index].name = action.table.table.name;
      state.tables[index].restaurantId = action.table.table.restaurantId;
      let filterTouchSaleTables3 = state.originalTouchSaleTables.filter(
        (u) => state.tables.filter((t) => t.name === u.name).length === 0
      );
      return {
        ...state,
        showScanModal: false,
        tables: clone(state.tables),
        touchSaleTables: clone(filterTouchSaleTables3),
      };

    case actions.UPDATE_SCANNED_QR_TABLE:
      return {
        ...state,
        scannedQRTable: clone(action.table),
        tableScanStatus: action.scanStatus === 2 ? 2 : state.tableScanStatus,
      };

    case actions.SCAN_QR_TABLE_SUCCESS:
      return {
        ...state,
        scannedQRTable: action.scannedQRTable,
        scanQRTableSuccess: true,
        showScanner: false,
        tableScanStatus: action.status,
      };

    case actions.GET_QR_TABLES_SUCCESS:
      return {
        ...state,
        tables: action.tables,
        originalTables: action.tables,
      };

    case actions.GET_QR_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
        originalUsers: action.users,
      };

    case actions.UPDATE_QR_USER: {
      return {
        ...state,
        user: action.user,
      };
    }

    case actions.DELETE_QR_USER_SUCCESS: {
      let users = state.users.filter((u) => u.id !== action.id);
      return {
        ...state,
        users: clone(users),
      };
    }

    case actions.SAVE_QR_USER_SUCCESS: {
      const users = state.users;
      const index = users.findIndex((u) => u.id === state.user.id);
      users[index] = clone(state.user);

      return {
        ...state,
        users: clone(users),
        user: state.user,
        showEditModal: !state.showEditModal,
      };
    }

    case actions.OPEN_QR_MODAL: {
      // Filter touchSaleTables based on the logic
      let filterTouchSaleTables1 = state.originalTouchSaleTables.filter(
        (u) => state.tables.filter((t) => t.name === u.name).length === 0
      );

      // Generate GUID function
      function generateGUID() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
          (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
          ).toString(16)
        );
      }

      return {
        ...state,
        showScanModal: true,
        tableScanStatus: 0,
        touchSaleTables: clone(filterTouchSaleTables1),
        // Autofill scannedQRTable
        scannedQRTable: {
          name: "",
          restaurantId: 0,
          identifier: generateGUID(),
        },
        autofilllGuid: true,
      };
    }

    default:
      return state;
  }
}
